export const setUserToken = (token: string): void => {
    localStorage.setItem('jwtToken', token);
};

export const getUserToken = (): string | null => {
    return localStorage.getItem('jwtToken');
};

export const clearUserToken = (): void => {
    localStorage.removeItem('jwtToken');
    // Also clear cached user details when token is cleared
    localStorage.removeItem('user-details');
    localStorage.removeItem('user-details-timestamp');
};